import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AvatarApp from './ui/screens/AvatarApp';
import ServiceManagementWrapper from './ui/screens/ServiceManagementWrapper';
import { MsalProvider } from '@azure/msal-react';
import msalConfig from './auth/config';
import Toast from './ui/components/Toast';

const App = () => {
  return (
    <MsalProvider instance={msalConfig}>
      <Toast>
        <Router>
          <Routes>
            <Route path="/gestion-servicios/*" element={<ServiceManagementWrapper />} />
            <Route path="*" element={<AvatarApp />} />
          </Routes>
        </Router>
      </Toast>
    </MsalProvider>
  );
};

export default App;
